/**
 * Re-export shared time picker (kept path for appointments imports).
 */
export { HmTimeField } from '../../shared/ui/HmTimeField';
